
const getModules = {
	prototype: () => import(
		/* webpackChunkName: "prototype" */ "./prototype/prototype"
	),
	hero: () => import(
		/* webpackChunkName: "hero" */ "./hero/hero"
	),
	textContent: () => import(
		/* webpackChunkName: "textContent" */ "./text-content/text-content"
	),
	fullMedia: () => import(
		/* webpackChunkName: "fullMedia" */ "./full-media/full-media"
	),
	doubleMedia: () => import(
		/* webpackChunkName: "doubleMedia" */ "./double-media/double-media"
	),
	overMediaText: () => import(
		/* webpackChunkName: "overMediaText" */ "./over-media-text/over-media-text"
	),
	doubleText: () => import(
		/* webpackChunkName: "doubleText" */ "./double-text/double-text"
	),
	infiniteSlider: () => import(
		/* webpackChunkName: "infiniteSlider" */ "./infinite-slider/infinite-slider"
	)
};

export { getModules };
